
import React from 'react'

export default props => (
  <svg {...props} className="ChangeColorLight" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle className="stroke" cx="16" cy="16" r="7" strokeWidth="2" />
    <path className="stroke" d="M16 3V6" strokeWidth="2" strokeLinecap="round" />
    <path className="stroke" d="M16 26V29" strokeWidth="2" strokeLinecap="round" />
    <path className="stroke" d="M6 16L3 16" strokeWidth="2" strokeLinecap="round" />
    <path className="stroke" d="M29 16L26 16" strokeWidth="2" strokeLinecap="round" />
    <path className="stroke" d="M26.1112 5.88945L23.2226 8.53051" strokeWidth="2" strokeLinecap="round" />
    <path className="stroke" d="M5.88879 5.88945L8.77741 8.53051" strokeWidth="2" strokeLinecap="round" />
    <path className="stroke" d="M8.77765 23.2224L5.88876 26.1113" strokeWidth="2" strokeLinecap="round" />
    <path className="stroke" d="M26.1112 26.1105L23.2226 23.2216" strokeWidth="2" strokeLinecap="round" />
  </svg>
)
